import { render, staticRenderFns } from "./multiselect.vue?vue&type=template&id=9074b88e&scoped=true"
import script from "./multiselect.vue?vue&type=script&lang=js"
export * from "./multiselect.vue?vue&type=script&lang=js"
import style0 from "./multiselect.vue?vue&type=style&index=0&id=9074b88e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9074b88e",
  null
  
)

export default component.exports